import { Button } from "antd";
import { Formik, Form, FormikValues } from "formik";
import React, { useState } from "react";
import { useRef } from "react";
import { UploadDocumentModal } from "../../../models/Documents/documents.model";
import { DocumentsRejected } from "../../../models/User/user.model";
import KYCService from "../../../services/KYCService/kyc.service";
import VideoRecorder from "../../../views/SignUp/VideoKYC/VideoRecorder";
import AlertModal from "../AlertModal";
import DocumentUpload from "../DocumentUpload";
import "./pendingKycDocuments.scss";
import { UPLOAD_DOCUMENTS_CONSTANTS } from "../../constants/views/KYCVerification/uploadDocumentsConstants";
import { RejectedDocumentTypeEnum } from "../../../enums/rejectedDocumentType.enum";

const { PHOTOGRAPH, KENYAN_ID_PROOF, KRA_PIN, VERIFICATION_VIDEO, DOCUMENT } =
  RejectedDocumentTypeEnum;

const { UPLOAD_DOCUMENT, CONSTRAIN, DOCUMENT_UPLOAD_FIELDS, RESUBMIT } =
  UPLOAD_DOCUMENTS_CONSTANTS;
const {
  PHOTOGRAPH_FIELD,
  ID_PROOF_FIELD,
  KRA_PIN_FIELD,
  RE_UPLOAD_APPROVAL_LETTER,
} = DOCUMENT_UPLOAD_FIELDS;

interface PendingKycDocumentsProps {
  documents: DocumentsRejected[];
  getUserDetails: Function;
  isHide?: boolean;
}

const PendingKycDocuments = (props: PendingKycDocumentsProps) => {
  const { documents, getUserDetails, isHide } = props;

  const [openDocumentUpload, setOpenDocumentUpload] =
    useState<RejectedDocumentTypeEnum>();
  const [openVideoUpload, setOpenVideoUpload] = useState<boolean>(false);

  const formikRef = useRef(null);

  const { uploadKYCDocuments, loading } = KYCService();

  const handleSubmit = async (values: FormikValues) => {
    if (!Object.values(values).some((val) => !!val)) {
      return;
    }
    const documents = Object.assign(new UploadDocumentModal(), values);
    documents.reupload = 1;
    try {
      await uploadKYCDocuments(documents, true);

      getUserDetails();
      (formikRef.current as any).resetForm();
      setOpenDocumentUpload(undefined);
    } catch (error) {}
  };
  const handleClose = () => {
    (formikRef.current as any).resetForm();
    setOpenDocumentUpload(undefined);
    setOpenVideoUpload(false);
  };

  const resubmitHandler = (document?: RejectedDocumentTypeEnum) => () =>
    document
      ? document === VERIFICATION_VIDEO
        ? setOpenVideoUpload(true)
        : setOpenDocumentUpload(document)
      : void 0;

  const formikProps = {
    initialValues: {
      ...new UploadDocumentModal(),
    },
    onSubmit: handleSubmit,
  };

  return (
    <div className="pending-documents__container">
      {documents.map((document) => (
        <div className="pending-document">
          <div className="pending-document--name">
            <p className="title">{document?.document?.replaceAll("_", " ")}</p>
            {!isHide ? (
              <p className="reason">Reason : {document?.reason}</p>
            ) : (
              <p></p>
            )}
          </div>
          <div className="pending-document--action">
            {document?.document && (
              <Button
                type="primary"
                onClick={resubmitHandler(document?.document)}
              >
                {RESUBMIT}
              </Button>
            )}
          </div>
        </div>
      ))}
      <AlertModal
        className="footer-header-less"
        visible={openVideoUpload}
        onOk={() => {}}
        onCancel={() => {}}
      >
        <VideoRecorder
          disableClose={true}
          setKycStep={() => {
            getUserDetails();
          }}
          afterResubmit={() => {
            getUserDetails();
            setOpenVideoUpload(false);
          }}
        ></VideoRecorder>
      </AlertModal>
      <AlertModal
        title={UPLOAD_DOCUMENT}
        visible={!!openDocumentUpload}
        onOk={() => (formikRef.current as any).submitForm()}
        confirmLoading={loading}
        onCancel={handleClose}
      >
        <p>{CONSTRAIN}</p>
        <Formik
          innerRef={formikRef}
          {...formikProps}
          enableReinitialize
          onSubmit={(values) => handleSubmit(values)}
        >
          {({ values, setFieldValue }) => (
            <Form>
              {openDocumentUpload === DOCUMENT && (
                <DocumentUpload
                  {...RE_UPLOAD_APPROVAL_LETTER}
                  value={values.registrationDocument}
                  setFieldValue={setFieldValue}
                />
              )}
              {openDocumentUpload === PHOTOGRAPH && (
                <DocumentUpload
                  {...PHOTOGRAPH_FIELD}
                  value={values.photograph}
                  setFieldValue={setFieldValue}
                />
              )}
              {openDocumentUpload === KENYAN_ID_PROOF && (
                <DocumentUpload
                  {...ID_PROOF_FIELD}
                  value={values.idProof}
                  setFieldValue={setFieldValue}
                />
              )}
              {openDocumentUpload === KRA_PIN && (
                <DocumentUpload
                  {...KRA_PIN_FIELD}
                  value={values.KRAPin}
                  setFieldValue={setFieldValue}
                />
              )}
            </Form>
          )}
        </Formik>
      </AlertModal>
    </div>
  );
};

export default PendingKycDocuments;
